import { Component, OnInit } from '@angular/core';
import { MfPanelComponent } from '../mf-panel/mf-panel.component';

@Component({
  selector: 'app-auto-panel-nav',
  templateUrl: './auto-panel-nav.component.html',
  styleUrls: ['./auto-panel-nav.component.css']
})
export class AutoPanelNavComponent implements OnInit {
  public parent: any;
  public navs = new Array();
  constructor() {
  }
  ngOnInit(): void {

    if (this.parent && this.parent.parent.forms)
      this.navs = this.parent.parent.forms.filter(o => { return o.isAutoNavOption });
  }

  public navToItem(item) {
    this.parent.parent.navigateToIndex(item.index, 1, 0);
  }
}
